<template>
  <span>
    <exportar-nfse-maior-periodo />
    <Dialog
      class="test-box"
      header="Exportar Notas Fiscais"
      :visible.sync="showExportarNotas"
      :contentStyle="{ overflow: 'visible', width: '600px' }"
      :modal="true"
      :closable="false"
    >
      <div class="container">
        <div id="topo" class="row">
          <div class="col-md-4 col-lg-6 mb-3">
            <span class="p-fluid">
              <Calendar
                id="dataIni"
                name="dataFim"
                v-model="dataFatoGeradorIni"
                :showIcon="true"
                dateFormat="dd/mm/yy"
                placeholder="Data Inicial*"
                @keyup.enter="pesquisar"
                v-maska="'##/##/####'"
              />
            </span>
          </div>
          <div class="col-md-4 col-lg-6 mb-3">
            <span class="p-fluid">
              <Calendar
                id="dataFim"
                name="dataFim"
                v-model="dataFatoGeradorFim"
                :showIcon="true"
                dateFormat="dd/mm/yy"
                placeholder="Data Final*"
                @keyup.enter="pesquisar"
                v-maska="'##/##/####'"
              />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-12 mb-3">
            <span class="p-fluid">
              <AutoComplete
                id="tomador"
                v-model="selectedPessoa"
                :dropdown="true"
                :suggestions="filteredPessoas"
                @complete="searchPessoa($event)"
                @keyup.enter="pesquisar"
                field="detail"
                placeholder="Pesquisar CPF/CNPJ/Nome Tomador"
              />
            </span>
          </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-lg-12 mb-3">
              <span class="p-fluid">
                <AutoComplete
                  id="servico"
                  v-model="selectedServico"
                  :dropdown="true"
                  :suggestions="filteredServicos"
                  field="detail"
                  @complete="searchServico($event)"
                  placeholder="Pesquisar Serviço"
                >
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
          </div>
          <div class="row">
          <div class="col-md-12 mb-2">
            <span class="p-fluid">
              <Dropdown id="situacao" v-model="filtroSituacao" :options="filtroSituacoes" optionLabel="name"
                placeholder="Selecione uma Situação" />
            </span>
					</div>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button
              @click="downloadListagemXml()"
              href="#topo"
              type="button"
              label="Exportar Notas Fiscais"
              class="p-button-primary mr-2 p-button-success"
              icon="pi pi-download"
              :disabled="loading"
            />
          </div>

          <div>
            <Button
              @click="showExportarNotas = false"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>

          <div>
            <Button
              @click="exportarMaiorPeriodo()"
              href="#topo"
              type="button"
              label="Exportar Período Maior"
              class="p-button-primary mr-2 p-button"
              icon="pi pi-download"
              :disabled="loading"
            />
          </div>
        </div>
      </div>
    </Dialog>
  </span>
</template>

<script>
import { maska } from 'maska'
import ContribuinteServicoService from "@/services/tributario/contribuinte.servico.service";
import PessoaService from "@/services/nfse/pessoa.service";
import LoginService from "@/services/acesso/login.service";
import ReportService from "@/services/report.service";
import ExportarNfseMaiorPeriodo from './ExportarNfseMaiorPeriodo.vue';

export default {
  directives: { maska },
  name: "ExportarNotasFiscais",
  components: { ExportarNfseMaiorPeriodo },

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.notaAvulsa = this.currentUser.emiteNotaAvulsa;

    this.$root.$on("notaFiscal:exportar", () => {
      this.showExportarNotas = true;
      this.dataFatoGeradorIni = null;
      this.dataFatoGeradorFim = null;
      this.selectedPessoa = null;
      this.filteredPessoas = null;
      this.selectedServico = null;
      this.filteredServicos = null;
    });
  },

  data() {
    return {
      showExportarNotas: false,
      currentUser: null,
      dataFatoGeradorIni: null,
      dataFatoGeradorFim: null,
      selectedPessoa: null,
      filteredPessoas: null,
      selectedServico: null,
      filteredServicos: null,
      notaAvulsa: null,
      filtroSituacao: "",
      filtroSituacoes: [
        { name: "Todos", key: "T" },
        { name: "Ativa", key: "A" },
        { name: "Cancelada", key: "C" },
        { name: "Substituida", key: "S" }
      ],
    };
  },

  methods: {
    searchPessoa(event) {
      setTimeout(async () => {
        this.filteredPessoas = await PessoaService.findAllByConttribuinteFiltro(
          event.query,
          ""
        );
      }, 550);
    },
    searchServico(event) {
      if (this.currentUser.configuracao.idBolHabilitaCnaeNf == "N") {
        if (this.notaAvulsa) {
          // Se for nota avulsa exibir todos os serviços
          setTimeout(async () => {
            this.filteredServicos =
              await ContribuinteServicoService.findAllNfAvulsa(
                event.query,
                this.currentUser.contribuinte.idContribuinte
              );
          }, 250);
        } else {
          setTimeout(async () => {
            this.filteredServicos =
              await ContribuinteServicoService.findAllServicosByContribuinteFiltro(
                event.query,
                this.currentUser.contribuinte.idContribuinte
              );
          }, 250);
        }
      } else {
        // Buscar lista de CNAE, posteriormente...
      }
    },
    downloadListagemXml() {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = "É necessário informar o contribuinte!";
      } else if (!this.dataFatoGeradorIni) {
        msg = "É necessário informar a data Inicial!";
      } else if (!this.dataFatoGeradorFim) {
        msg = "É necessário informar a data Final!";
      } else if(!this.filtroSituacao && !this.filtroSituacao.key){
        msg = "É necessário informar uma Situação!"
      }

      if (!msg) {
        this.processando(true);
        ReportService.downloadListXmlCompleto(
          this.currentUser.contribuinte.idContribuinte,
          this.dataFatoGeradorIni,
          this.dataFatoGeradorFim,
          (this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : ""),
          (this.selectedServico && this.selectedServico.idServico ? this.selectedServico.idServico.idServicoItem : ""),
          this.$root,
          (this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null )
        )
          .then(
            (data) => {
              console.log(data);
            },
            (error) => {
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    
    exportarMaiorPeriodo(){
      this.$root.$emit("notaFiscal:exportarMaiorPeriodo");
    },

    processando(show) {
      if (show) {
        this.$parent.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.$parent.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
  },

  computed: {
    loading() {
      return this.$parent.loading;
    },
  },
};
</script>

<style scoped>
</style>